export default {
  en: {
    title: 'Instagram Preview',
    dateOrderWarning: 'According to the order of the grid, the scheduled dates are not correct.',
  },
};
